module.exports = __webpack_public_path__ + "img/background_homepage_footer.6bbcd43e.webp";